import {
  DirectionProvider,
  rem,
  ScrollArea,
  Stack,
  Stepper,
} from "@mantine/core";
import { IconCircleCheck } from "@tabler/icons-react";
import { useEffect, useRef } from "react";

export type StepperDto = {
  icon: JSX.Element;
  label: string;
};

type Props = {
  active: number;
  steppers: StepperDto[];
};

function CustomStepper({ active, steppers }: Props) {
  const viewport = useRef<HTMLDivElement>(null);
  const stepRefs = useRef<(HTMLButtonElement | null)[]>([]);

  useEffect(() => {
    const currentStep = stepRefs.current[active];
    if (currentStep && viewport.current) {
      // Scroll the step into view inside the viewport
      currentStep.scrollIntoView({
        behavior: "smooth",
        block: "nearest", // Adjust this as per your needs (start, center, end, nearest)
        inline: "center", // Adjust horizontal scrolling
      });
    }
  }, [active]);

  return (
    <DirectionProvider initialDirection="rtl">
      <ScrollArea scrollbars="x" offsetScrollbars viewportRef={viewport}>
        <Stack >
          <Stepper
            active={active}
            size="sm"
            color="green"
            wrap={false}
            styles={{
              step: {
                gap: 10,
                flexDirection: "column",
                alignItems: "center",
              },
              stepBody: {
                width: "100%",
                margin: 0,
                textAlign: "center",
              },
              stepLabel: {
                fontSize: rem(12),
              },
              separator: {
                width: "20px",
                marginBottom: "20px",
              },
            }}
            completedIcon={
              <IconCircleCheck style={{ width: rem(30), height: rem(30) }} />
            }
          >
            {steppers.map((stepper, index) => (
              <Stepper.Step
                key={index}
                icon={stepper?.icon}
                label={stepper?.label}
                ref={(el) => {
                  if (el && stepRefs.current) {
                    stepRefs.current[index] = el;
                  }
                }}
              />
            ))}
          </Stepper>
        </Stack>
      </ScrollArea>
    </DirectionProvider>
  );
}

export default CustomStepper;
